import ccj from './ccj.svg';
import casting from './casting.svg';

export const logos = {
	ccj,
	casting
};
